/* ============================================================
   MyAthanClock — The Wall Mount product page
   - Finish swatch → variant + 3-image swap (hero / front / detail)
   - Thumbnail switcher (4 scenes)
   - Qty stepper + Add to cart (Horizon section-render pattern)
   - FAQ accordion, toast
   ============================================================ */
(function(){
  'use strict';

  function init(section){
    if (!section || section.dataset.mymInit === '1') return;
    section.dataset.mymInit = '1';

    var dataEl = section.querySelector('[data-mym-data]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch(e){ console.error('mym: invalid product JSON', e); return; }

    var product = data.product;
    var media   = data.media || {};     // { "Birch Beige": {hero, front, detail}, ... }
    var moneyFormat = data.moneyFormat || '${{amount}}';

    // Fallbacks: if a finish has no image assigned, use the first available
    var finishNames = Object.keys(media);
    var firstMedia = finishNames.length ? media[finishNames[0]] : null;

    /* ---------- Elements ---------- */
    var $ = function(sel){ return section.querySelector(sel); };
    var $$ = function(sel){ return section.querySelectorAll(sel); };

    var v1 = $('#mym-v1img-' + section.dataset.sectionId);
    var v2 = $('#mym-v2img-' + section.dataset.sectionId);
    var v3 = $('#mym-v3img-' + section.dataset.sectionId);
    var t1 = $('#mym-t1img-' + section.dataset.sectionId);
    var t2 = $('#mym-t2img-' + section.dataset.sectionId);
    var t3 = $('#mym-t3img-' + section.dataset.sectionId);
    var feat04 = $('[data-mym-feat04-img]');

    var finishNameEl = $('[data-mym-finish-name]');
    var priceEls = $$('[data-mym-price]');
    var priceCompareEl = $('[data-mym-price-compare]');
    var variantInput = $('[data-mym-variant-input]');
    var addBtn = $('[data-mym-addcart]');
    var ctaText = $('[data-mym-cta-text]');
    var qtyInput = $('[data-mym-qty-input]');
    var countPill = $('[data-mym-count-pill]');
    var toast = $('[data-mym-toast]');
    var toastMsg = $('[data-mym-toast-msg]');
    var restock = $('[data-mym-restock]');

    /* ---------- Money helper ---------- */
    function formatMoney(cents){
      var amount = (cents / 100);
      var formatted = amount.toFixed(2);
      var withCommas = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat
        .replace('{{amount}}', withCommas)
        .replace('{{amount_no_decimals}}', Math.round(amount).toString())
        .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
    }

    /* ---------- Variant sync ---------- */
    function findVariantByFinish(finishName){
      // finish is the first (and only) option on this product
      for (var i=0; i<product.variants.length; i++){
        var v = product.variants[i];
        if ((v.options && v.options[0] === finishName) || v.title === finishName) return v;
      }
      return product.variants[0];
    }

    function updateBuyState(variant){
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;

      var priceStr = formatMoney(variant.price);
      priceEls.forEach(function(el){ el.textContent = priceStr; });

      if (priceCompareEl){
        if (variant.compare_at_price && variant.compare_at_price > variant.price){
          priceCompareEl.textContent = formatMoney(variant.compare_at_price);
          priceCompareEl.style.display = '';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }

      var available = variant.available !== false;
      if (addBtn){
        addBtn.disabled = !available;
        addBtn.classList.toggle('disabled', !available);
      }
      if (ctaText){
        ctaText.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (restock){
        restock.style.display = available ? 'none' : '';
      }
    }

    /* ---------- Finish swatch swap ---------- */
    function setFinish(name){
      var slots = media[name] || firstMedia || {};
      var hero  = slots.hero  || (firstMedia && firstMedia.hero)  || '';
      var front = slots.front || (firstMedia && firstMedia.front) || '';
      var detail= slots.detail|| (firstMedia && firstMedia.detail)|| '';

      if (v1) v1.src = hero;
      if (v2) v2.src = front;
      if (v3) v3.src = detail;
      if (t1) t1.src = hero;
      if (t2) t2.src = front;
      if (t3) t3.src = detail;
      if (feat04) feat04.src = detail;

      if (finishNameEl) finishNameEl.textContent = name;

      // Swatch pressed state
      $$('.mym-swatch').forEach(function(s){
        s.setAttribute('aria-pressed', s.dataset.name === name ? 'true' : 'false');
      });

      // Variant sync
      updateBuyState(findVariantByFinish(name));
    }

    $$('.mym-swatch').forEach(function(sw){
      sw.addEventListener('click', function(){
        setFinish(sw.dataset.name);
      });
    });

    /* ---------- Initial finish ---------- */
    // Prefer the URL/selected variant's option, else Walnut Brown, else first
    var initialFinish = null;
    if (product.selected_variant && product.selected_variant.options){
      initialFinish = product.selected_variant.options[0];
    }
    if (!initialFinish){
      if (finishNames.indexOf('Walnut Brown') !== -1) initialFinish = 'Walnut Brown';
      else if (finishNames.length) initialFinish = finishNames[0];
      else initialFinish = product.variants[0] && product.variants[0].options[0];
    }
    if (initialFinish) setFinish(initialFinish);

    /* ---------- Thumbnails / scenes ---------- */
    $$('.mym-thumb').forEach(function(t, i){
      t.addEventListener('click', function(){
        $$('.mym-thumb').forEach(function(x){ x.setAttribute('aria-selected','false'); });
        t.setAttribute('aria-selected','true');
        $$('.mym-scene').forEach(function(s){ s.classList.remove('active'); });
        var sceneId = t.dataset.scene;
        var sc = section.querySelector('#' + sceneId);
        if (sc) sc.classList.add('active');
        if (countPill) countPill.textContent = (i+1) + ' / ' + $$('.mym-thumb').length;
      });
    });

    /* ---------- Qty stepper ---------- */
    function getQty(){ return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    var minus = $('[data-mym-qty-minus]');
    var plus  = $('[data-mym-qty-plus]');
    if (minus) minus.addEventListener('click', function(){
      var q = Math.max(1, getQty() - 1);
      if (qtyInput) qtyInput.value = q;
    });
    if (plus) plus.addEventListener('click', function(){
      var q = Math.min(99, getQty() + 1);
      if (qtyInput) qtyInput.value = q;
    });

    /* ---------- FAQ accordion ---------- */
    $$('.mym-qa button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var qa = btn.parentElement;
        var isOpen = qa.hasAttribute('open');
        $$('.mym-qa').forEach(function(x){
          x.removeAttribute('open');
          var b = x.querySelector('button');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen){
          qa.setAttribute('open', '');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Add to cart ---------- */
    function showToast(msg){
      if (!toast) return;
      if (toastMsg) toastMsg.textContent = msg;
      toast.classList.add('show');
      clearTimeout(showToast._t);
      showToast._t = setTimeout(function(){ toast.classList.remove('show'); }, 2200);
    }

    if (addBtn){
      addBtn.addEventListener('click', function(e){
        e.preventDefault();
        if (addBtn.disabled) return;

        var variantId = variantInput ? variantInput.value : null;
        var qty = getQty();
        if (!variantId) { console.warn('mym: no variant selected'); return; }

        var originalHTML = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.classList.add('disabled');
        addBtn.innerHTML = '<span>Adding…</span>';

        // Horizon cart pattern — collect cart-items-component section IDs
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function(el){
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });

        var body = { id: variantId, quantity: qty };
        if (sectionIds.length){
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function(r){
          if (!r.ok) return r.json().then(function(err){ throw err; });
          return r.json();
        })
        .then(function(response){
          // Fire Horizon-native event so cart-items-component + cart-drawer refresh
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: 'mym-product-form',
              data: {
                source: 'product-form-component',
                itemCount: qty,
                sections: response.sections || {}
              }
            }
          }));
          var finishLabel = (finishNameEl && finishNameEl.textContent) || '';
          showToast(qty + ' × Wall Mount' + (finishLabel ? ' (' + finishLabel + ')' : '') + ' added');
          addBtn.innerHTML = '<span style="color:#B7D3A8">✓ Added</span>';
          setTimeout(function(){
            addBtn.innerHTML = originalHTML;
            addBtn.disabled = false;
            addBtn.classList.remove('disabled');
          }, 1800);
        })
        .catch(function(err){
          console.error('mym: cart add failed', err);
          var msg = (err && err.description) || 'Error — try again';
          addBtn.innerHTML = '<span style="color:#c44">' + msg + '</span>';
          setTimeout(function(){
            addBtn.innerHTML = originalHTML;
            addBtn.disabled = false;
            addBtn.classList.remove('disabled');
          }, 2200);
        });
      });
    }
  }

  function initAll(){
    document.querySelectorAll('.mym-section[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on section reload from the theme editor
  document.addEventListener('shopify:section:load', function(e){
    var sec = e.target.querySelector ? e.target.querySelector('.mym-section[data-section-id]') : null;
    if (sec) init(sec);
  });
})();